import $http from "@/plugins/axios"

export default {
    state: {
        ListJobTitles: [],
    },
    getters: {
        ListJobTitles: state => state.ListJobTitles
    },
    actions: {
        async getListJobTitles({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.ListJobTitles = data
        }
    }
}